import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { ApiService } from './api.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { WindowService } from './window.service';
import { Observable } from 'rxjs';

@Injectable()
export class OnlineClientService implements OnDestroy {
  private worker: Worker | undefined | null;
  constructor(private apiService: ApiService, private windowService: WindowService, public router: Router) {
    if (typeof Worker !== 'undefined' && !this.worker) {
      this.worker = new Worker(new URL('../app.worker.ts', import.meta.url), { type: 'module' });
      this.startKeepAlive();
    } else {
      console.error('Web Workers are not supported in this environment');
    }
  }
  ngOnDestroy(): void {
    this.stopKeepAlive();
  }

  public disconnectWithLogout() {
    this.apiService.sendBeacon('onlineclient/disconnectWithLogout', {});
  }

  public disconnect() {
    return this.apiService.post('onlineclient/disconnect');
  }

  public disconnectSessionAndKeepDocument() {
    this.apiService.sendBeacon('onlineclient/disconnectSessionAndKeepDocument', {});
  }

  private startKeepAlive() {
    // Tell the worker to start the keep alive process
    this.worker?.postMessage({
      type: 'startKeepAlive',
      url: `${environment.endpoints.apiUrl}/onlineclient/keepalive`,
      interval: 30000,
      sessionId: this.windowService.getSessionIdFromWindow(),
    });
  } // Refactored method to perform API POST reques

  public stopKeepAlive() {
    if (this.worker) {
      this.worker.postMessage({ type: 'stopKeepAlive' });
      this.worker.terminate();
      this.worker = null;
    }
  }

  public hasContentSwitchLock(): Observable<boolean> {
    return this.apiService.get<boolean>('onlineclient/hascontentswitchlock');
  }
}
